import React from "react";
import ProfilePicture from "../../../shared/ProfilePicture";
import { isCurrentUser } from "../../../../../api/sendbird";
import moment from "moment";

export default class Channel extends React.Component {
  componentDidMount() {}
  onClickChannel = () => this.props.onSelectChannel(this.props.channel);
  render() {
    console.log("this.props.channe", this.props.channel);
    const members = this.props.channel.members.filter((a) => !isCurrentUser(a));
    return (
      <li className={`media p-3 ${this.props.isSelected ? "active" : ""}`} onClick={this.onClickChannel}>
        {members.length ? (
          <>
            <div className="chatItem p-3">
              <div className="chatItem__image">
                {members.map((member, i) => (
                  <ProfilePicture
                    key={member.userId}
                    className={i === members.length - 1 ? "mr-3" : "mr-n3"}
                    user={{ profile_picture: { url: member.profileUrl } }}
                  />
                ))}
              </div>
              <div className="chatItem__content">
                <div className="chatItem__content__row justify-content-between">
                  <span className="title">{members[0].nickname}</span>
                  <span className="date">
                    {this.props.channel.lastMessage && moment.unix(this.props.channel.lastMessage.createdAt).format("h:mm a")}
                  </span>
                </div>
                <div className="last-message">
                  {this.props.channel.lastMessage && this.props.channel.lastMessage.data && JSON.parse(this.props.channel.lastMessage.data).length
                    ? "Sent an attachment"
                    : this.props.channel.lastMessage
                    ? this.props.channel.lastMessage.message
                    : null}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="chatItem p-3">
            <div className="chatItem__image">
              <ProfilePicture className="mr-3" user={{}} />
            </div>
            <div className="chatItem__content">
              <div className="chatItem__content__row justify-content-between">
                <span className="title">Unknown</span>
              </div>
            </div>
          </div>
        )}
      </li>
    );
  }
}
